module.exports = __webpack_public_path__ + "static/media/galeryFloating2.da3debb5.jpg";